import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Button, Col, Form, Input, Label, Row, Table } from "reactstrap"
// Toastify
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Slide } from "react-toastify"
import API from "../../apis"
import { withTranslation } from "react-i18next"
import { AvForm, AvField } from "availity-reactstrap-validation"
import Select from "react-select"
const AddOrientation = props => {
  const [array, setArray] = useState([])
  const [specialite, setSpecialite] = useState([])
  const [selectSpecilaite, setSelectSpecilaite] = useState("")
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthEtudiant"))
  var annee_id = userAuthScolarite.user.annee_id
  var user_id = userAuthScolarite.user.id
  var etudiant_id = userAuthScolarite.user.id_etudiant
  var specialite_id = userAuthScolarite.user.specialite_id
  const [order, setOrder] = useState([])
  const save = async () => {
      API.post("candidature_orientation/submit", {
        annee_id,
        etudiant_id,
        specialite_source_id: specialite_id,
        array,
      }).then(res => {
        toast.success(" 🔓✔️ Orientation ajoutée Avec succès", {
          containerId: "A",
        })
        props.setSection(2)
      })
  }
  useEffect(async () => {
    const resSpec = await API.post(
      "candidature_orientation/calculer_score_etudiant",
      {
        annee_id,
        etudiant_id,
        specialite_source_id: specialite_id,
      }
    ).then(resSpec => {
      setArray(resSpec.data.Scores)
      if (resSpec.data.Scores.length > 0) {
        const generatedOrder = Array.from(
          { length: resSpec.data.Scores.length },
          (_, i) => ({
            value: i + 1,
            label: (i + 1).toString(),
          })
        )

        setOrder(generatedOrder)
      }
    })
  }, [])
  const handleOrderChange = (index, selectedOption) => {
    const newArray = [...array]
    newArray[index].ordre_preference = selectedOption
    setArray(newArray)
  }
  const getAvailableOptions = currentIndex => {
    const selectedValues = array
      .map(item => item.ordre_preference?.value)
      .filter(Boolean)

    return order.filter(opt => {
      // garder la valeur actuelle de la ligne
      if (array[currentIndex].ordre_preference?.value === opt.value) return true

      // exclure les valeurs déjà utilisées
      return !selectedValues.includes(opt.value)
    })
  }
  return (
    <React.Fragment>
      <Row>
        <AvForm>
          <Form>
            <Row>
              <Table className="mt-3" striped bordered hover>
                <thead>
                  <th style={{ textAlign: "center" }}>Order</th>
                  <th style={{ textAlign: "center" }}>Spécialité a choisie</th>
                  <th style={{ textAlign: "center" }}>
                    Votre score de chaque spécialite
                  </th>
                </thead>
                <tbody>
                  {array.map((specialite, index) => (
                    <tr key={index}>
                      <td style={{ textAlign: "center" }}>
                        <Select
                          options={getAvailableOptions(index)}
                          isSearchable={true}
                          isClearable={true}
                          value={specialite.ordre_preference || null}
                          onChange={e => handleOrderChange(index, e)}
                        />
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {specialite.specialite_destination_name}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {specialite.score_final}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Row>
          </Form>
          <div style={{ display: "flex", justifyContent: "center" }}>
            {" "}
            <Col lg="6">
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
                className="text-center mt-4"
              >
                <Button
                  type="button"
                  color="warning"
                  className="btn btn-warning  mb-2 me-2"
                  onClick={props.back}
                >
                  {props.t("Annuler")}
                </Button>
              </div>
            </Col>
            <Col lg="6">
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                }}
                className="text-center mt-4"
              >
                <button
                  type="button"
                  className="btn btn-primary "
                  onClick={save}
                >
                  {props.t("Confirmer")}
                </button>
              </div>
            </Col>
          </div>
        </AvForm>
      </Row>
      <ToastContainer
        transition={Slide}
        enableMultiContainer
        containerId={"A"}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={2500}
      />
    </React.Fragment>
  )
}

export default withTranslation()(AddOrientation)
AddOrientation.propTypes = {
  history: PropTypes.object,
  back: PropTypes.object,
  setSection: PropTypes.object,
  t: PropTypes.any,
}
